import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { fontSize } from "@mui/system";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import { POTION_DAO_STAKING_ADDRESS } from "../../../Config";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import POTION_DAO_STAKING_ABI from "../../../Config/POTION_DAO_STAKING_ABI.json";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import { useAccount } from "wagmi";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import Loader from "../../Loader/Loader";
import BigNumber from "bignumber.js";
import style from "./staking.module.css"

const useStyles = makeStyles({
  bin1: {
    border: "1px solid gray !important",
    borderRadius: "10px ",
    width: "100%",
    background: "black",
    color: "#423A2A !important",
    height: "auto !important",
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&:focus-Visible": {
      outline: "2px solid rgba(255, 255, 255, 0.22) !important",
      border: "2px solid rgba(255, 255, 255, 0.22) !important",
    },
    "&:hover": {
      border: "2px solid #fff",
    },

    "&:focus": {
      boxShadow: "none !important",
      border: "none !important",
      borderRadius: "5px !important ",
    },
    "& input": {
      padding: "15px 20px",
      fontSize: "18px",
      color: "white",
      "&::placeholder": {
        color: "white",
      },
    },
  },

  error: {
    color: "#f14668 !important",
    fontSize: "12px !important",
    paddingTop: "3px",
    wordBreak: "break-all",
  },
  max: {
    color: "white !important",
    fontSize: "16px !important",
    fontWeight: "700 !important",
  },
  wthdrawBtn: {
    backgroundColor: "#00f666",
    padding: "10px 30px",
    color: "black",
    borderRadius: "10px",
  },
  required: {
    color: "#f14668",
    fontSize: "12px !important",
  },
});
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    background: "#202020",
    border: "1px solid gray",
    borderRadius: "20px",
    padding: " 20px",

    // maxWidth:"650px !important",
    width: "100%",
    // overflow:"hidden"
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        background: "#fff",
        color: "000",
        borderBottom: "1px solid #202020",
        textAlign: "center",
        fontSize: "20px",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const WithdrawModal = ({ open, setOpen }) => {
  const { address } = useAccount();
  const [max, setMax] = useState("0.0");
  const [withdrawamount, setwithdrawamount] = useState("0");


  const { data: unlockedBalance } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "unlockedBalance",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      setMax(parseFloat?.(convertWeiToEther?.(data?.toString())).toFixed(5));
    },
  });

  const setMaxWithdraw = () => {
    setwithdrawamount(max)
  }

  const classes = useStyles();
  const validationSchema = yup.object({
    amount: yup
      .number()
      .positive("Amount must be a positive integer")
      .max(max, `Amount must be less than or equal to ${max}`),
  });
  const formik = useFormik({
    // validateOnMount: true,
    initialValues: {
      amount: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        await withdrawContract?.writeAsync();
      } catch (error) {
        //console.log(error);
      }
    },
    onReset: (values) => {
      // handleClose()
    },
  });

  const handleClose = () => {
    setOpen(false);
    formik.values.amount = "";
  };

  const {
    _useContractWrite: withdrawContract,
    _useWaitForTransaction: withdrawWaitForTransaction,
  } = useCustomContractWrite({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "withdraw",
    Args: [
      convertEtherToWei?.(withdrawamount === "" ? "0" : withdrawamount),
    ],
    isEnabled:
      address !== undefined &&
      parseFloat?.(withdrawamount === "" ? "0" : withdrawamount) >
      0 &&
      parseFloat?.(
        withdrawamount === "" ? "0" : withdrawamount
      ) <= parseFloat?.(convertWeiToEther?.(unlockedBalance?.toString())),
  });

  useEffect(() => {
    if (withdrawWaitForTransaction?.isSuccess || withdrawContract?.isSuccess) {
      handleClose();
    }
  }, [withdrawWaitForTransaction?.isSuccess]);
  function handleOtter(e){
    let flage = [...e.target.classList].includes("outterwithdraw")
    if(flage){
      handleClose()
    }
  }
   
  const stackhandleInputChange = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,5})?$/.test(value);
    if (isStack) {
      setwithdrawamount(value);
    }
  };
  

  return (
    <div className={style.widthdraw_modal_parent+" w-100 h-100 position-fixed top-0 left-0 d-flex justify-content-center align-items-center outterwithdraw "} onClick={handleOtter}>
      <div className={style.widthdraw_modal}>
        <h3 className="text-center mb-4 fs-5 fw-semibold">Withdraw Unlocked Balance</h3>
        <p >Your Unlocked Balance: {parseFloat?.(
                convertWeiToEther?.(unlockedBalance?.toString())
              ).toFixed(2)}{" "} SHiELD</p>
        <label htmlFor="">Enter Amount to Withdraw *</label>
        <div className={style.inputdiv+" d-flex"}>
          <input type="number" placeholder="0.0" className="border-0 bg-transparent flex-grow-1" value={withdrawamount} onChange={stackhandleInputChange} />
          <button onClick={setMaxWithdraw} className="btn3">Max</button>
        </div>
        <div className="d-flex mt-4 justify-content-center">
          <button   onClick={async () => {
                        try {
                          await withdrawContract?.writeAsync();
                        } catch (error) {
                          //console.log(error);
                        }
                      }} className="btn1 py-2 px-3">
                        {(withdrawWaitForTransaction?.isLoading ||
                        withdrawContract?.isLoading) && <Loader color="#423A2A" />}
                        Withdraw</button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawModal;
